import { ReactNode } from 'react';
import { ChildrenProps } from 'styled-system';

const withStringOrComponent = (
  value: ReactNode,
  WrappedComponent: React.ComponentType<ChildrenProps>,
) => {
  return typeof value === 'string' ? (
    <WrappedComponent>{value}</WrappedComponent>
  ) : (
    value
  );
};

export default withStringOrComponent;
